<template>
  <div class="page">
    <el-dialog
      title="客保到期提醒"
      :visible.sync="expireDialog.visible"
      width="980px"
      custom-class="expire-dialog"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-table
        v-loading="expireDialog.loading"
        :data="expireDialog.list"
        border
        stripe
        max-height="420"
      >
        <el-table-column
          prop="budget_name"
          label="聚合名称"
          min-width="160"
        />
        <el-table-column
          prop="identify_code"
          label="识别名称"
          min-width="220"
          show-overflow-tooltip
        />
        <el-table-column
          prop="sale_type_text"
          label="预算类型"
          width="110"
        />
        <el-table-column
          prop="product_names"
          label="主类预算产品"
          min-width="180"
          show-overflow-tooltip
        />
        <el-table-column
          prop="agent_name"
          label="代理商"
          min-width="180"
          show-overflow-tooltip
        />
        <el-table-column
          prop="release_time"
          label="到期时间"
          width="180"
        />
        <el-table-column
          prop="remaining_text"
          label="剩余时间"
          width="100"
        />
      </el-table>

      <el-pagination
        :current-page="expireDialog.page"
        :page-sizes="[10, 20, 50]"
        :page-size="expireDialog.page_size"
        layout="total, sizes, prev, pager, next"
        :total="expireDialog.total"
        style="margin-top: 16px; text-align: right;"
        @size-change="handleExpireDialogSizeChange"
        @current-change="handleExpireDialogPageChange"
      />

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="expireDialog.visible = false"
        >
          我知道了
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="直投聚合客保审核结果"
      :visible.sync="reviewResultDialog.visible"
      width="1080px"
      custom-class="expire-dialog"
      append-to-body
      :close-on-click-modal="false"
    >
      <div style="margin: 12px 0px; display: flex; justify-content: space-between;">
        <div>
          共 <span style="color: #409eff">{{ reviewResultDialog.counts.all }}</span> 条审核结果   
          <span style="color: #67c23a; margin-left: 24px;">已通过 {{ reviewResultDialog.counts.approved }} 条</span>  
          <span style="color: #f56c6c; margin-left: 24px;">已驳回 {{ reviewResultDialog.counts.rejected }} 条</span> 
        </div>
        <div style="color: #f56c6c">已驳回的聚合请在修改截止前，在【我的聚合】页重新提交，逾期将进入公海。</div>
      </div>
      
      <el-table
        v-loading="reviewResultDialog.loading"
        :data="reviewResultDialog.list"
        border
        stripe
        max-height="420"
      >
        <el-table-column
          prop="budget_name"
          label="聚合名称"
          min-width="160"
        />

        <el-table-column
          prop="identify_code"
          label="识别名称"
          min-width="220"
          show-overflow-tooltip
        />

        <el-table-column
          prop="audit"
          label="审核结果"
          width="110"
        >
          <template slot-scope="scope">
            <el-tag :type="scope.row.audit === 2 ? 'danger' : scope.row.audit === 1 ? 'success' : 'info'">
              {{ scope.row.audit === 2 ? '已驳回' : scope.row.audit === 1 ? '已通过' : '--' }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column
          prop="audit_time"
          label="审核日期"
          min-width="180"
        />

        <el-table-column
          prop="end_time"
          label="客保期限"
          min-width="180"
        >
          <template slot-scope="scope">
            <div :style="{color: scope.row.end_date_color}">{{ scope.row.end_date_text || '--' }}</div>
            <div>{{ scope.row.end_time }}</div>
          </template>
        </el-table-column>
        
        <el-table-column
          prop="audit_reason"
          label="审核意见"
          width="180"
        />
      </el-table>

      <el-pagination
        :current-page="reviewResultDialog.page"
        :page-sizes="[10, 20, 50]"
        :page-size="reviewResultDialog.page_size"
        layout="total, sizes, prev, pager, next"
        :total="reviewResultDialog.total"
        style="margin-top: 16px; text-align: right;"
        @size-change="handleReviewResultDialogSizeChange"
        @current-change="handleReviewResultDialogPageChange"
      />

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="reviewResultDialog.visible = false"
        >
          我知道了
        </el-button>
      </div>
    </el-dialog>

    <div
      v-if="showExpireNotice"
      class="expire-notice"
    >
      <div class="expire-notice__icon">
        <i class="el-icon-warning-outline" />
      </div>

      <div class="expire-notice__viewport">
        <div
          class="expire-notice__track"
          :class="{ 'is-animating': expireNotice.animating }"
          :style="expireNoticeTrackStyle"
          @transitionend="handleExpireNoticeTransitionEnd"
        >
          <div class="expire-notice__item">
            {{ currentExpireNotice.text }}
          </div>
          <div
            v-if="hasMultipleExpireNotice"
            class="expire-notice__item"
          >
            {{ nextExpireNotice.text }}
          </div>
        </div>
      </div>
    </div>

    <div class="query-conditions">
      <el-form
        :inline="true"
        @submit.native.prevent
        class="query-form"
      >
        <el-row :gutter="20" class="query-row">
          <el-col v-show="queryFieldVisibility.budget_name" :span="queryColSpan" class="query-item">
            <el-form-item>
              <el-input
                v-model="query.form.budget_name"
                clearable
                placeholder="请输入聚合名称"
              />
            </el-form-item>
          </el-col>
          <el-col v-show="queryFieldVisibility.identify_code" :span="queryColSpan" class="query-item">
            <el-form-item>
              <el-input
                v-model="query.form.identify_code"
                clearable
                placeholder="请输入识别名称"
              />
            </el-form-item>
          </el-col>
          <el-col v-show="queryFieldVisibility.owner_name" :span="queryColSpan" class="query-item">
            <el-form-item>
              <el-input
                v-model="query.form.owner_name"
                clearable
                placeholder="请输入所属"
              />
            </el-form-item>
          </el-col>
          <!-- <el-col v-show="queryFieldVisibility.subject_type" :span="queryColSpan" class="query-item">
            <el-form-item>
              <el-select
                v-model="query.form.subject_type"
                placeholder="请选择主体类型"
                style="width: 100%;"
                clearable
              >
                <el-option
                  v-for="item in SubjectTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col v-show="queryFieldVisibility.sale_type" :span="queryColSpan" class="query-item">
            <el-form-item>
              <el-select
                v-model="query.form.sale_type"
                placeholder="请选择预算类型"
                style="width: 100%;"
                clearable
              >
                <el-option
                  v-for="item in SaleTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col v-show="queryFieldVisibility.product_ids" :span="queryColSpan" class="query-item">
            <el-form-item>
              <el-input
                v-model="query.form.product_name"
                clearable
                placeholder="请输入产品名称"
              />
            </el-form-item>
          </el-col>

          <el-col v-show="queryFieldVisibility.agent_name" :span="queryColSpan" class="query-item">
            <el-form-item>
              <el-input
                v-model="query.form.agent_name"
                clearable
                placeholder="请输入代理商"
              />
            </el-form-item>
          </el-col>

          <el-col v-show="queryFieldVisibility.status" :span="queryColSpan" class="query-item">
            <el-form-item>
              <el-select
                v-model="query.form.status"
                placeholder="请选择聚合状态"
                style="width: 100%;"
                clearable
              >
                <el-option
                  v-for="item in StatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <!-- <el-col v-show="queryFieldVisibility.customer_from" :span="queryColSpan" class="query-item">
            <el-form-item>
              <el-select
                v-model="query.form.customer_from"
                placeholder="请选择客户来源"
                style="width: 100%;"
                clearable
              >
                <el-option
                  v-for="item in CustomerFromOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col> -->

          <el-col v-show="queryFieldVisibility.is_weight" :span="queryColSpan" class="query-item">
            <el-form-item>
              <el-select
                v-model="query.form.is_weight"
                placeholder="配比进度"
                style="width: 100%;"
                clearable
              >
                <el-option
                  v-for="item in WeightStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col v-show="queryFieldVisibility.is_across" :span="queryColSpan" class="query-item">
            <el-form-item>
              <el-select
                v-model="query.form.is_across"
                placeholder="是否跨组"
                style="width: 100%;"
                clearable
              >
                <el-option
                  v-for="item in IsCrossGroupOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="queryActionSpan" class="query-item query-item--actions">
            <div class="query-buttons">
              <el-button
                plain
                type="primary"
                :loading="table.loading"
                @click="handleReset"
              >
                重置
              </el-button>

              <el-button
                type="primary"
                :loading="table.loading"
                @click="handleFilter"
              >
                查询
              </el-button>
              <el-button
                v-if="showQueryToggle"
                type="text"
                class="query-toggle"
                @click="toggleQueryExpand"
              >
                {{ queryExpanded ? '收起' : '展开' }}
                <i :class="queryExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
              </el-button>
            </div>
          </el-col>

        </el-row>
      </el-form>

      <div class="query-extra-actions" style="margin-top: 12px;">
        <el-checkbox v-model="showAssign" label="待分配聚合" border></el-checkbox>

        <div class="query-extra-buttons">
          <!-- <el-button
            type="danger"
            plain
            :disabled="!hasAggregationSelection"
            @click="handleBatchUnbindOpen"
          >
            批量解绑
          </el-button> -->

          <!-- <el-button
            v-if="isAdminOrLeader"
            type="primary"
            plain
            :disabled="!hasAggregationSelection"
            @click="handleBatchTransOpen"
          >
            批量流转
          </el-button> -->

          <el-button
            v-if="canAddAggregation"
            type="primary"
            @click="handleEdit('Add')"
          >
            新增聚合
          </el-button>

          <el-button
            type="primary"
            plain
            @click="handleDownload"
          >
            下载
          </el-button>
        </div>
      </div>
    </div>

    <div
      v-loading="table.loading"
      class="query-data"
    >
      <!-- list -->
      <el-table
        ref="aggregationTable"
        stripe
        :data="table.list"
        :row-key="row => row.id"
        border
        style="width: 100%"
        @selection-change="handleAggregationSelectionChange"
        @sort-change="handleTableSortChange"
      >
        <el-table-column
          type="selection"
          :reserve-selection="true"
          width="55"
        />
        <el-table-column
          prop="budget_name"
          label="聚合名称"
          min-width="200"
        />
        <el-table-column
          prop="identify_code"
          label="识别名称"
          width="300"
        >
          <template slot-scope="scope">
            <div
              style="display: flex; justify-content: space-between; width: 280px;"
              v-if="scope.row.identify_code"
            >
              <el-tag
                class="no-wrap-tag"
                type="success"
                style="margin-right: 8px;"
              >
                {{(scope.row.identify_code ? scope.row.identify_code.replace(/[，,]/g, ',').split(',') : [])[0]}}
              </el-tag>

              <el-popover
                v-if="(scope.row.identify_code ? scope.row.identify_code.replace(/[，,]/g, ',').split(',') : []).length > 1"
                placement="top"
                width="400"
                trigger="click">
                <div style="display: flex; flex-wrap: wrap; row-gap: 8px; max-height: 400px; overflow: auto;">
                  <el-tag
                    v-bind:key="item"
                    type="success"
                    v-for="item in (scope.row.identify_code.replace(/[，,]/g, ',').split(','))"
                    style="margin-right: 8px;"
                  >
                    {{item}}
                  </el-tag>
                </div>
                <el-button slot="reference" type="text" style="flex: 1;">更多</el-button>
              </el-popover>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="sale_type"
          label="预算类型"
          width="120"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.sale_type === '1'">直投</div>
            <div v-else-if="scope.row.sale_type === '2'">渠道</div>
            <div v-else>--</div>
          </template>
        </el-table-column>

        <el-table-column
          prop="products"
          label="主类预算产品"
          width="160"
        >
          <template slot-scope="scope">
            <div
              v-if="scope.row.product_names"
              style="display: flex; justify-content: space-between; width: 140px;">
              <el-tag
                class="no-wrap-tag"
                type="success"
                style="margin-right: 8px;"
              >
                {{(scope.row.product_names ? scope.row.product_names.replace(/[，,]/g, ',').split(',') : [])[0]}}
              </el-tag>

              <el-popover
                v-if="(scope.row.product_names ? scope.row.product_names.replace(/[，,]/g, ',').split(',') : []).length > 1"
                placement="top"
                width="400"
                trigger="click">
                <div style="display: flex; flex-wrap: wrap; row-gap: 8px; max-height: 400px; overflow: auto;">
                  <el-tag
                    v-bind:key="item"
                    type="success"
                    v-for="item in (scope.row.product_names.replace(/[，,]/g, ',').split(','))"
                    style="margin-right: 8px;"
                  >
                    {{item}}
                  </el-tag>
                </div>
                <el-button slot="reference" type="text" style="flex: 1;">更多</el-button>
              </el-popover>
            </div>

            <span v-else>-</span>

            <!-- <el-tag
              v-bind:key="item"
              type="success"
              v-for="item in (scope.row.product_names ? scope.row.product_names.split(',') : [])"
              style="margin-right: 8px;"
            >
              {{item}}
            </el-tag> -->
          </template>
        </el-table-column>

        <el-table-column
          prop="agent_name"
          label="代理商"
          width="120"
        >
          <template slot-scope="scope">
            <el-button
              v-if="!scope.row.agent_name"
              type="success"
              size="small"
              @click="handleAssign(scope.row)"
            >
              分配
            </el-button>
            <span v-else>{{ scope.row.agent_name || '-' }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="status"
          label="聚合状态"
          width="120"
        >
         <template slot-scope="scope">
            <el-tag
              type="info"
              v-if="scope.row.status === '0'"
            >
              失效
            </el-tag>
            <el-tag
              type="success"
              v-else
            >
              {{ StatusMap[scope.row.status] }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column
          prop="owners_name"
          v-if="isOriginSale"
          label="业绩配比"
          min-width="120"
          :sortable="isOriginSale"
        >
          <template slot-scope="scope">
            {{ scope.row.weight }}
          </template>
        </el-table-column>


        <el-table-column
          prop="owners_name"
          v-if="!isOriginSale && isChannelSale"
          label="所属"
          min-width="120"
          :sortable="isOriginSale"
        >
          <template slot-scope="scope">
            {{ scope.row._owner_name }}
          </template>
        </el-table-column>

        <el-table-column
          prop="owners_name"
          v-if="!isOriginSale && !isChannelSale"
          label="归属"
          min-width="120"
        >
          <template slot-scope="scope">
            {{ scope.row._owner_name }}
          </template>
        </el-table-column>

        <el-table-column
          prop="owners_name"
          v-if="!isOriginSale && !isChannelSale"
          label="业绩配比"
          min-width="140"
          :sortable="true"
        >
          <template slot-scope="scope">
            <div style="display: flex; justify-content: space-between; align-items: center; width: 120px;">
              {{ scope.row._owner_weight }}

              <el-popover
                v-if="(scope.row.owners || []).length > 1"
                placement="top"
                width="400"
                trigger="click">
                <div style="display: flex; flex-wrap: wrap; row-gap: 8px; max-height: 400px; overflow: auto;">
                  <el-tag
                    v-bind:key="item"
                    type="success"
                    v-for="item in (scope.row.owners || [])"
                    style="margin-right: 8px;"
                  >
                    {{item.owner_name}} {{ item.weight || 0 }}%
                  </el-tag>
                </div>
                <el-button slot="reference" type="text" style="flex: 1;">更多</el-button>
              </el-popover>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="is_weight"
          label="配比进度"
          v-if="!isChannelSale"
          min-width="200"
        >
          <template slot-scope="scope">
            <el-tag
              type="info"
              v-if="scope.row.is_weight == '0'"
            >
              待配比
            </el-tag>
            <el-tag
              type="success"
              v-else-if="scope.row.is_weight == '1'"
            >
              已配比
            </el-tag>
            <span v-else> - </span>
          </template>
        </el-table-column>

        <el-table-column
          fixed="right"
          label="操作"
          width="140"
        >
          <template slot-scope="scope">
              <el-button
                type="primary"
                plain
                size="small"
                @click="handleEdit('Update', scope.row)"
              >
                修改
              </el-button>

             <el-dropdown trigger="click" style="margin-left: 12px;">
              <span class="el-dropdown-link" style="color: #1890ff; font-size: 12px; cursor: pointer;">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <el-button
                    v-if="isAdminOrLeader && !isChannelSale"
                    type="primary"
                    size="small"
                    style="width: 100%; margin-bottom: 8px;"
                    @click="handleTrans(scope.row)"
                  >
                    配比划分
                  </el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button
                    type="danger"
                    plain
                    size="small"
                    style="width: 100%; margin-bottom: 8px;"
                    @click="handleUnbind(scope.row)"
                  >
                    解绑
                  </el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button
                    type="warning"
                    plain
                    size="small"
                    style="width: 100%; margin-bottom: 8px;"
                    @click="handleCtrlLogOpen(scope.row)"
                  >
                    日志
                  </el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button
                    type="primary"
                    plain
                    size="small"
                    style="width: 100%; margin-bottom: 8px;"
                    @click="handleCtrlCancel(scope.row)"
                  >
                    {{ scope.row.status === '0' ? '置为有效' : '置为失效' }}
                  </el-button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page.sync="query.form.page"
        :page-sizes="[10, 20, 30, 50]"
        layout="total, sizes, prev, pager, next"
        :total="table.total"
        style="margin-top: 30px; float: right"
        @size-change="handlePageSizeChange"
        @current-change="handleQueryPage"
      />
    </div>

    <!-- edit -->
    <form-dialog
      :visible.sync="editForm.display"
      :title="(editForm.type === 'Add' ? '新增' : '修改') + '聚合信息'"
      :loading="editForm.loading"
      width="800px"
      @close="handleFormClose"
      @submit="submitEditFormAction"
    >
      <el-form
        ref="editForm"
        :model="editForm.form"
        :rules="editForm.rules"
        label-width="120px"
      >
        <el-form-item
          label="识别名称"
          prop="identify_code"
        >
          <el-input
            type="textarea"
            :rows="3"
            v-model="editForm.form.identify_code"
            placeholder="请输入识别名称，支持录入多个识别名称；多个之间用逗号隔开"
            @blur="handleCompanyName"
          />
        </el-form-item>

        <el-form-item
          label="主体类型"
          prop="subject_type"
        >
          <el-radio-group v-model="editForm.form.subject_type">
            <el-radio :label="'2'">公司</el-radio>
            <el-radio :label="'1'">个人</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item
          label="聚合名称"
          prop="budget_name"
        >
          <el-input
            v-model="editForm.form.budget_name"
            placeholder="请输入聚合名称"
          />
        </el-form-item>
        <div style="margin-left: 120px; margin-bottom: 16px; color: #999;">
          规则：主体商号命名，例如上海XXX网络有限公司，商号：XXX<br/>
          若出现重复，地域+商号，例如上海XXX
        </div>

        <el-form-item
          label="预算类型"
          prop="sale_type"
        >
          <el-select
            v-model="editForm.form.sale_type"
            placeholder="请选择预算类型"
            style="width: 100%;"
          >
            <el-option
              v-for="item in SaleTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          label="主类预算产品"
          prop="product_ids"
          class="my_el_form_item"
        >
          <el-select
            v-model="editForm.form.product_ids"
            placeholder="输入产品名称"
            style="width: 100%;"
            clearable
            filterable
            multiple
            remote
            reserve-keyword
            :remote-method="handleSearchProducts"
            :loading="productsLoading"
          >
            <el-option
              v-for="item in ProductOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <!-- <el-form-item
          v-if="isAdminOrLeader && isChannelSale"
          label="所属"
          prop="owners"
        >
          <el-select
            v-model="editForm.form.owners"
            filterable
            multiple
            clearable
            remote
            :remote-method="_searchSalors"
            placeholder="输入并选择所属"
            :loading="editProdSalorDlg.searchLoading"
            style="width: 100%"
          >
            <el-option
              v-for="item in editProdSalorDlg.options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item> -->

        <!-- 占比 -->
        <el-form-item
          v-if="isAdminOrChannelSale"
          :label="isChannelSale ? '所属' : '配比划分'"
          prop="owners"
        >
          <div class="transfer-owner-list">
            <div
              v-for="(owner, index) in editForm.form.owners"
              :key="'edit-owner-' + index"
              class="transfer-owner-item"
            >
              <el-select
                v-model="owner.owner"
                filterable
                clearable
                remote
                :remote-method="_searchSalors2"
                placeholder="请选择销售名称"
                :loading="editProdSalorDlg.searchLoading"
                class="transfer-owner-select"
                @change="clearEditOwnerWeightValidate"
                :disabled="(owner.is_show == '0') || (editForm.form.owners[index] && ['趣头条', '代理'].includes(editForm.form.owners[index].owner_name))"
              >
                <el-option
                  v-for="item in editProdSalorDlg.options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>

              <el-input
                v-if="!isChannelSale && !(editForm.form.owners[index] && ['趣头条', '代理'].includes(editForm.form.owners[index].owner_name))"
                v-model.trim="owner.weight"
                placeholder="占比"
                class="transfer-owner-weight"
                clearable
                @input="handleEditOwnerWeightInput(index, owner.weight)"
                @blur="handleEditOwnerWeightBlur(index)"
                :disabled="(owner.is_show == '0') || (editForm.form.owners[index] && ['趣头条', '代理'].includes(editForm.form.owners[index].owner_name))"
              >
                <span slot="append">%</span>
              </el-input>

              <el-button
                v-if="!(owner.is_show == '0') && (isAdmin || (!isAdmin && index > 0))"
                type="danger"
                plain
                @click="removeEditOwnerWeightRow(index)"
              >
                删除
              </el-button>
            </div>

            <el-button
                type="primary"
                plain
                @click="appendEditOwnerWeightRow"
              >
                新增
            </el-button>
          </div>
        </el-form-item>

        <el-form-item
          label="代理商"
          prop="agent_name"
          v-if="isAdminOrChannelSale"
        >
          <el-input
            v-model="editForm.form.agent_name"
            placeholder="输入代理商"
          />
        </el-form-item>

        <el-form-item
          label="备注"
          prop="remark"
        >
          <el-input
            type="textarea"
            :rows="3"
            placeholder="输入备注信息"
            maxlength="100"
            v-model="editForm.form.remark">
          </el-input>
        </el-form-item>

      </el-form>
    </form-dialog>

    <!-- trans -->
    <form-dialog
      :visible.sync="transForm.display"
      title="聚合任务配比划分"
      :loading="transForm.loading"
      width="800px"
      @close="handleFormClose"
      @submit="submitTransFormAction"
    >
      <el-form
        ref="transForm"
        :model="transForm.form"
        :rules="transForm.rules"
        label-width="120px"
      >
        <el-form-item
          label="聚合名称"
          prop="budget_name"
        >
          <el-input
            v-model="transForm.form.budget_name"
            placeholder="请输入聚合名称"
            disabled
          />
        </el-form-item>
        <el-form-item
          label="识别名称"
          prop="identify_code"
        >
          <el-input
            type="textarea"
            :rows="3"
            v-model="transForm.form.identify_code"
            placeholder="请输入识别名称，支持录入多个识别名称；多个之间用逗号隔开"
            @blur="handleCompanyName"
            disabled
          />
        </el-form-item>

        <el-form-item
          label="预算类型"
          prop="sale_type"
        >
          <el-select
            v-model="transForm.form.sale_type"
            placeholder="请选择预算类型"
            style="width: 100%;"
            disabled
          >
            <el-option
              v-for="item in SaleTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          label="当前销售名称"
          prop="belong_name"
        >
          <el-input
            v-model="transForm.form.belong_name"
            placeholder="请输入销售名称"
            disabled
          />
        </el-form-item>

        <el-form-item
          label="当前客户来源"
          prop="customer_from"
        >
          <el-input
            v-model="transForm.form.customer_from"
            placeholder="当前客户来源"
            disabled
          />
        </el-form-item>

        <el-form-item
          label="配比划分"
          prop="owners"
          v-if="isAdminOrLeader"
        >
          <div class="transfer-owner-list">
            <div
              v-for="(owner, index) in transForm.form.owners"
              :key="'trans-owner-' + index"
              class="transfer-owner-item"
            >
              <el-select
                v-model="owner.owner"
                filterable
                clearable
                remote
                :remote-method="_searchSalors2"
                placeholder="请选择销售名称"
                :loading="editProdSalorDlg.searchLoading"
                class="transfer-owner-select"
                @change="clearTransOwnerValidate"
                :disabled="(owner.is_show == '0') || (transForm.form.owners[index] && ['趣头条', '代理'].includes(transForm.form.owners[index].owner_name))"
              >
                <el-option
                  v-for="item in editProdSalorDlg.options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>

              <el-input
                v-if="!isChannelSale && !(transForm.form.owners[index] && ['趣头条', '代理'].includes(transForm.form.owners[index].owner_name))"
                v-model.trim="owner.weight"
                placeholder="占比"
                class="transfer-owner-weight"
                clearable
                @input="handleTransOwnerWeightInput(index, owner.weight)"
                @blur="handleTransOwnerWeightBlur(index)"
                :disabled="(owner.is_show == '0') || (transForm.form.owners[index] && ['趣头条', '代理'].includes(transForm.form.owners[index].owner_name))"
              >
                <span slot="append">%</span>
              </el-input>

              <el-button
                v-if="!(owner.is_show == '0') && (isAdmin || (!isAdmin && index > 0))"
                type="danger"
                plain
                size="small"
                @click="removeTransOwner(index)"
              >
                删除
              </el-button>
            </div>
            <el-button
              type="primary"
              plain
              @click="appendTransOwner"
            >
              新增
            </el-button>
          </div>
        </el-form-item>    
      </el-form>
    </form-dialog>

    <!-- unbind -->
    <form-dialog
      :visible.sync="unbindForm.display"
      title="提示"
      width="800px"
      @close="() => { unbindForm.display = false; unbindForm.form = {} }"
      @submit="handleUnbindConfirm"
    >
      是否确认解绑？
    </form-dialog>

    <form-dialog
      :visible.sync="assignForm.display"
      title="提示"
      width="800px"
      @close="() => { assignForm.display = false; assignForm.form = {} }"
      @submit="handleAssignConfirm"
    >
      申请分配代理商？
    </form-dialog>

    <form-dialog
      :visible.sync="batchUnbindDialog.display"
      :loading="batchUnbindDialog.loading"
      title="提示"
      width="520px"
      @close="handleBatchUnbindClose"
      @submit="handleBatchUnbindConfirm"
    >
      是否确认解绑所选聚合？
    </form-dialog>

    <el-dialog
      title="批量解绑结果"
      :visible.sync="batchUnbindResultDialog.display"
      width="720px"
      @close="handleBatchUnbindResultClose"
    >
      <div class="batch-unbind-result">
        <div class="batch-unbind-result__summary">
          <div class="batch-unbind-result__card batch-unbind-result__card--success">
            <div class="batch-unbind-result__label">成功数</div>
            <div class="batch-unbind-result__value">
              {{ batchUnbindResultDialog.success_count }}
            </div>
          </div>
          <div class="batch-unbind-result__card batch-unbind-result__card--failed">
            <div class="batch-unbind-result__label">失败数</div>
            <div class="batch-unbind-result__value">
              {{ batchUnbindResultDialog.failed_count }}
            </div>
          </div>
        </div>

        <div class="batch-unbind-result__details">
          <div class="batch-unbind-result__details-title">解绑失败明细</div>
          <el-table
            v-if="batchUnbindResultDialog.failed_items.length"
            :data="batchUnbindResultDialog.failed_items"
            border
            max-height="360"
          >
            <el-table-column
              prop="budget_name"
              label="聚合名称"
              min-width="220"
            />
            <el-table-column
              prop="reason"
              label="失败原因"
              min-width="320"
            />
          </el-table>
          <div
            v-else
            class="batch-unbind-result__empty"
          >
            本次解绑没有失败项
          </div>
        </div>
      </div>
      <span slot="footer">
        <el-button
          type="primary"
          @click="handleBatchUnbindResultClose"
        >
          我知道了
        </el-button>
      </span>
    </el-dialog>

    <form-dialog
      :visible.sync="batchTransDialog.display"
      :loading="batchTransDialog.loading"
      title="批量流转"
      width="520px"
      @close="handleBatchTransClose"
      @submit="handleBatchTransConfirm"
    >
      <el-form
        ref="batchTransDialog"
        :model="batchTransDialog.form"
        :rules="batchTransDialog.rules"
        label-width="90px"
      >
        <el-form-item
          label="流转至"
          prop="owner"
        >
          <el-select
            v-model="batchTransDialog.form.owner"
            filterable
            clearable
            remote
            :remote-method="_searchSalors2"
            placeholder="请选择销售名称"
            :loading="editProdSalorDlg.searchLoading"
            style="width: 100%"
          >
            <el-option
              v-for="item in editProdSalorDlg.options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </form-dialog>

    <!--日志-->
    <el-dialog
      title="批量流转结果"
      :visible.sync="batchTransResultDialog.display"
      width="720px"
      @close="handleBatchTransResultClose"
    >
      <div class="batch-unbind-result">
        <div class="batch-unbind-result__summary">
          <div class="batch-unbind-result__card batch-unbind-result__card--success">
            <div class="batch-unbind-result__label">成功数</div>
            <div class="batch-unbind-result__value">
              {{ batchTransResultDialog.success_count }}
            </div>
          </div>
          <div class="batch-unbind-result__card batch-unbind-result__card--failed">
            <div class="batch-unbind-result__label">失败数</div>
            <div class="batch-unbind-result__value">
              {{ batchTransResultDialog.failed_count }}
            </div>
          </div>
        </div>

        <div class="batch-unbind-result__details">
          <div class="batch-unbind-result__details-title">流转失败明细</div>
          <el-table
            v-if="batchTransResultDialog.failed_items.length"
            :data="batchTransResultDialog.failed_items"
            border
            max-height="360"
          >
            <el-table-column
              prop="budget_name"
              label="聚合名称"
              min-width="220"
            />
            <el-table-column
              prop="reason"
              label="失败原因"
              min-width="320"
            />
          </el-table>
          <div
            v-else
            class="batch-unbind-result__empty"
          >
            本次流转没有失败项
          </div>
        </div>
      </div>
      <span slot="footer">
        <el-button
          type="primary"
          @click="handleBatchTransResultClose"
        >
          我知道了
        </el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="日志"
      :visible.sync="logVisible"
      width="800px"
    >
      <el-table
        :data="logList"
      >
        <el-table-column
          label="操作时间"
          prop="create_time"
        />
        <el-table-column
          label="操作编号"
          prop="id"
        />
        <el-table-column
          label="操作人"
          prop="operator"
        />
        <el-table-column
          label="操作内容"
          prop="content"
        />
      </el-table>
      <div style="margin-top: 10px; text-align: right;">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="logPage"
          :page-size="logPageSize"
          :total="logTotal"
          @current-change="handleChangeLogPage"
        />
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Request from '@/core/QuRequest';
import { FormDialog } from '@/components';
import queryGridByContainer from '@/common/js/queryGridByContainer';

const req = new Request();
let self;

function hasValue(value) {
  if (value === 0 || value === '0' || value === false) return true;
  if (value === undefined || value === null) return false;
  if (typeof value === 'string') return value.trim() !== '';
  if (Array.isArray(value)) return value.length > 0;
  return true;
}

// function safeTrim(value) {
//   if (typeof value === 'string') return value.trim();
//   if (value === undefined || value === null) return '';
//   return String(value).trim();
// }

function pickValue(source = {}, keys = []) {
  for (let i = 0; i < keys.length; i += 1) {
    const key = keys[i];
    if (
      Object.prototype.hasOwnProperty.call(source, key) &&
      hasValue(source[key])
    ) {
      return source[key];
    }
  }
  return '';
}

export default {
  name: 'AggregationManageMy',
  components: { FormDialog },
  data() {
    return {
      expireNotice: {
        list: [],
        currentIndex: 0,
        animating: false,
        timer: null,
      },
      expireDialog: {
        visible: false,
        list: [],
        page: 1,
        page_size: 10,
        total: 0,
        loading: false,
        requestId: 0,
      },
      reviewResultDialog: {
        visible: false,
        list: [],
        page: 1,
        page_size: 10,
        total: 0,
        loading: false,
        requestId: 0,
        counts: {"approved": 0, "rejected": 0, "all": 0},
      },
      productsLoading: false,
      showAssign: false,
      StatusMap: {
        1: '有效',
        0: '失效'
      },
      userInfo: {},
      unbindForm: {
        form: {},
        display: false
      },
      assignForm:{
        form: {},
        display: false
      },
      selectedAggregationRows: [],
      batchUnbindDialog: {
        display: false,
        loading: false,
      },
      batchUnbindResultDialog: {
        display: false,
        success_count: 0,
        failed_count: 0,
        failed_items: [],
      },
      batchTransResultDialog: {
        display: false,
        success_count: 0,
        failed_count: 0,
        failed_items: [],
      },
      batchTransDialog: {
        display: false,
        loading: false,
        form: {
          owner: '',
        },
        rules: {
          owner: [
            {
              required: true,
              message: '请输入流转对象',
              trigger: 'blur',
            },
          ],
        },
      },
      ProductOptions: [],
      table: {
        list: [],
        total: 0,
        loading: false,
      },
      query: {
        form: {
          budget_name: '',
          page: 1,
          page_size: 10,
          weight_order: '',
          subject_type: '',
          sale_type: '',
          product_ids: [],
          agent_name: '',
          status: '',
          customer_from: '',
          is_weight: '',
          is_across: undefined,
          identify_code: '', // 识别名称
          owner_name: '', // 销售名称
        },
      },
      editForm: {
        display: false,
        loading: false,
        type: 'Add',
        form: {
          id: '',
          budget_name: '',
          identify_code: '',
          sale_type: '',
          products_ids: [],
          agent_name: '',
          // owner: [],
          owners: [
            {
              // type: 'sales',
              owner: '',
              name: '',
              weight: '',
              // department_id: '',
              // locked: false,
            },
          ],
          owner_name: '',
          subject_type: 2,
          remark: '',
        },
        rules: {
          budget_name: [
            {
              required: true,
              message: '聚合名称必填',
              type: 'string',
              triggle: 'blur',
            },
            { min: 2, message: '长度必须大于 2 个字符', trigger: 'blur' }
          ],
          identify_code: [
            {
              required: true,
              message: '识别名称必填',
              type: 'string',
              triggle: 'blur',
            },
            {
              // pattern: /^[\u4e00-\u9fa5]+$/,
              // message: '只能输入中文',
              pattern: /^[\u4e00-\u9fa5(（)）,，]+$/,
              message: '只能包含汉字、中文括号（）或英文括号()',
              trigger: 'blur'
            },
            { min: 2, message: '长度必须大于 2 个字符', trigger: 'blur' }
          ],
          subject_type: [
            {
              required: true,
              message: '请选择主体类型',
              triggle: 'blur',
            },
          ],
          sale_type: [
            {
              required: true,
              message: '预算类型必选',
              triggle: 'blur',
            },
          ],
          // product_ids: [
          //   {
          //     required: true,
          //     message: '主类预算产品必选',
          //     triggle: 'blur',
          //     type: 'array'
          //   },
          // ],
          remark: [
            {
              pattern: /^[\u4e00-\u9fa5a-zA-Z0-9\s\p{P}]+$/u,
              message: '仅支持中英文、数字、符号',
              trigger: 'blur'
            },
            {
              max: 100,
              message: '字数限制在 100 字以内',
              trigger: 'blur'
            }
          ],
          owners: [
            {
              validator: (rule, value, callback) =>
                this.validateOwnerWeightRows(value, callback),
              trigger: 'submit',
            },
          ],
        },
      },
      transForm: {
        display: false,
        loading: false,
        type: 'Add',
        form: {
          id: '',
          budget_name: '',
          identify_code: '',
          sale_type: '',
          products_ids: [],
          agent_name: '',
          owners: [
            {
              type: 'sales',
              owner: '',
              name: '',
              weight: '',
              department_id: '',
              locked: false,
            },
          ],
          owner_name: '',
          subject_type: 2,
          remark: '',
        },
        rules: {
          budget_name: [
            {
              required: true,
              message: '聚合名称必填',
              type: 'string',
              triggle: 'blur',
            },
            { min: 2, message: '长度必须大于 2 个字符', trigger: 'blur' }
          ],
          identify_code: [
            {
              required: true,
              message: '识别名称必填',
              type: 'string',
              triggle: 'blur',
            },
            {
              // pattern: /^[\u4e00-\u9fa5]+$/,
              // message: '只能输入中文',
              pattern: /^[\u4e00-\u9fa5(（)）,，]+$/,
              message: '只能包含汉字、中文括号（）或英文括号()',
              trigger: 'blur'
            },
            { min: 2, message: '长度必须大于 2 个字符', trigger: 'blur' }
          ],
          subject_type: [
            {
              required: true,
              message: '请选择主体类型',
              triggle: 'blur',
            },
          ],
          sale_type: [
            {
              required: true,
              message: '预算类型必选',
              triggle: 'blur',
            },
          ],
          // product_ids: [
          //   {
          //     required: true,
          //     message: '主类预算产品必选',
          //     triggle: 'blur',
          //     type: 'array'
          //   },
          // ],
          remark: [
            {
              pattern: /^[\u4e00-\u9fa5a-zA-Z0-9\s\p{P}]+$/u,
              message: '仅支持中英文、数字、符号',
              trigger: 'blur'
            },
            {
              max: 100,
              message: '字数限制在 100 字以内',
              trigger: 'blur'
            }
          ],
          owners: [
            {
              validator: (rule, value, callback) =>
                this.validateOwnerWeightRows(value, callback),
              trigger: 'submit',
            },
          ],
        },
      },
      editProdSalorDlg: {
        searchLoading: false,
        options: [],
        form: {
          customer_id: '',
          product_id: '',
        },
      },
      logVisible: false,
      logId: '',
      logList: [],
      logTotal: 0,
      logPage: 1,
      logPageSize: 10,
      salesMetaMap: {},
      salers: [],
      queryExpanded: true,
    };
  },
  mixins: [queryGridByContainer],
  computed: {
    SaleTypeOptions() {
      return [
        {label: '直投', value: '1'},
        {label: '渠道', value: '2'},
      ]
      // if(this.userInfo.role_ids) {
      //   if (this.userInfo.role_ids.includes("1")) {
      //     return [
      //       {label: '直投', value: '1'},
      //       {label: '渠道', value: '2'},
      //     ]
      //   }
      //   if (this.userInfo.role_ids.includes("2") ||  this.userInfo.role_ids.includes("3")) {
      //     return [
      //       {label: '渠道', value: '2'},
      //     ]
      //   }
      //   return []
      // }
      // return []
    },

    StatusOptions() {
      return [
        {label: '有效', value: '1'},
        {label: '失效', value: '0'},
      ]
    },
    SubjectTypeOptions() {
      return [
        {label: '个人', value: '1'},
        {label: '公司', value: '2'},
      ]
    },

    WeightStatusOptions() {
      return [
        {label: '已配比', value: 1},
        {label: '待配比', value: 0},
      ]
    },
    IsCrossGroupOptions() {
      return [
        {label: '是', value: 1},
        {label: '否', value: 0},
      ]
    },
    CustomerFromOptions() {
      return [
        {label: '其他', value: '0'},
        {label: '自拓', value: '1'},
        {label: '共拓', value: '2'},
        {label: '流转', value: '3'},
        {label: '内部', value: '4'},
      ]
    },
    CustomerSourcesMap() {
      return {
        0: '',
        1: '自拓',
        2: '共拓',
        3: '流转',
        4: '内部'
      }
    },

    perms() {
      return this.$store.state.perms;
    },

    showSaler(){
      if(this.userInfo.role_ids) {
        return this.userInfo.role_ids.includes("3") ||  this.userInfo.role_ids.includes("1") || this.userInfo.role_ids.includes("30")
      }
      return false
    },

    canAddAggregation() {
      if(this.userInfo.role_ids) {
        // 1:超管，2是直客销售  3是直客销售leader
        return  this.userInfo.role_ids.includes("1") || this.userInfo.role_ids.includes("2") || this.userInfo.role_ids.includes("3") || this.userInfo.role_ids.includes("30")
      }
      return false
    },

    isChannelSale() {
      // 1是渠道销售
      if(this.userInfo.is_channel_sale) {
        return true
      }
      return false
    },
    isAdmin() {
      if(this.userInfo.role_ids) {
        // 1:超管，2是直客销售  3是直客销售leader
        return  this.userInfo.role_ids.includes("1")
      }
      return false
    },
    isAdminOrChannelSale() {
      if(this.userInfo.role_ids) {
        // 1:超管，2是直客销售  3是直客销售leader
        return  this.userInfo.role_ids.includes("1") || this.userInfo.role_ids.includes("30")
      }
      return false
    },
    isOriginSale() {
      if(this.userInfo.role_ids) {
        // 1:超管，2是直客销售  3是直客销售leader
        return  this.userInfo.role_ids.includes("2")
      }
      return false
    },

    isAdminOrLeader() {
      if(this.userInfo.role_ids) {
        // 1:超管，2是直客销售  3是直客销售leader
        return  this.userInfo.role_ids.includes("1") || this.userInfo.role_ids.includes("30") || this.userInfo.role_ids.includes("3")
      }
      return false
    },
    showEditOwnerSelect() {
      return this.isAdminOrChannelSale && this.editForm.type === 'Add';
    },
    showEditOwnerWeightSection() {
      return this.isAdminOrChannelSale && this.editForm.type === 'Update';
    },
    queryColumnsPerRow() {
      return Math.max(24 / this.queryColSpan, 1);
    },
    collapsedQueryCount() {
      return Math.min(Math.max(this.queryColumnsPerRow - 1, 1), this.queryFieldKeys.length);
    },
    visibleQueryFieldCount() {
      console.log(111111111, this.queryFieldKeys)
      return this.queryExpanded
        ? this.queryFieldKeys.length
        : this.collapsedQueryCount;
    },
    queryActionSpan() {
      const remainder = this.visibleQueryFieldCount % this.queryColumnsPerRow;
      const remainingColumns = remainder === 0
        ? this.queryColumnsPerRow
        : this.queryColumnsPerRow - remainder;

      return remainingColumns * this.queryColSpan;
    },

    queryFieldKeys() {
      let keys = ['budget_name', 'identify_code'];

      if (this.showSaler) {
         keys = keys.concat(['owner_name']);
      }

      keys = keys.concat([
        // 'subject_type',
        'sale_type',
        'product_ids',
        'agent_name',
        'status',
        // 'customer_from',
      ]);

      if(!this.isChannelSale) {
        keys = keys.concat(['is_weight'])
      }

      if (this.isAdmin) {
        keys = keys.concat(['is_across'])
      }

      return keys
    },

    queryFieldVisibility() {
      const visibility = {};

      this.queryFieldKeys.forEach((key, index) => {
        visibility[key] = index < this.visibleQueryFieldCount;
      });

      return visibility;
    },
    showQueryToggle() {
      return this.queryFieldKeys.length > this.collapsedQueryCount;
    },
    hasAggregationSelection() {
      return this.selectedAggregationRows.length > 0;
    },
    showExpireNotice() {
      return this.expireNotice.list.length > 0;
    },
    hasMultipleExpireNotice() {
      return this.expireNotice.list.length > 1;
    },
    currentExpireNotice() {
      return this.expireNotice.list[this.expireNotice.currentIndex] || { text: '' };
    },
    nextExpireNotice() {
      if (!this.hasMultipleExpireNotice) {
        return this.currentExpireNotice;
      }

      const nextIndex =
        (this.expireNotice.currentIndex + 1) % this.expireNotice.list.length;
      return this.expireNotice.list[nextIndex] || { text: '' };
    },
    expireNoticeTrackStyle() {
      return {
        transform: this.expireNotice.animating
          ? 'translateY(-44px)'
          : 'translateY(0)',
      };
    },
  },
  created() {
    this.getBudgetExpireNotice();
    this.getReviewResultNotice();
    this._getList();
    this.getUserInfo();
  },
  beforeDestroy() {
    this.clearExpireNoticeTimer()
  },
  methods: {
    normalizeResultDialogRow(row = {}) {
      let audit = pickValue(row, ['audit']) || '--';
      return {
        ...row,
        budget_name: pickValue(row, ['budget_name']) || '--',
        identify_code: pickValue(row, ['identify_code']) || '--',
        audit: pickValue(row, ['audit']) || '--',
        audit_date: pickValue(row, ['audit_date']) || '--',
        audit_time: pickValue(row, ['audit_time']) || '--',
        end_time: pickValue(row, ['end_time']) || '--',
        audit_reason:  pickValue(row, ['audit_reason']) || '--',
        end_date_text:  audit === 2 ? '修改截止' : audit === 1 ? '正式客保截止' : '--',
        end_date_color:  audit === 2 ? '#f56c6c' : audit === 1 ? '#666' : '#aaa'
      };
    },
    async getReviewResultNotice() {
      try {
        this.reviewResultDialog.page = 1;
        const res = await req.send(req.Apis.customer.aggregation.reviewResult, {
          page: 1,
          page_size: this.reviewResultDialog.page_size,
        });
        const data = res.data || {};
        const list = data.list || data.data || [];
        const sourceList = Array.isArray(list) ? list : [];
        const normalizedDialogList = sourceList
          .map(item => this.normalizeResultDialogRow(item))
          .filter(item => hasValue(item.budget_name));

        this.reviewResultDialog.list = normalizedDialogList;
        this.reviewResultDialog.total = Number(data.total || normalizedDialogList.length);
        this.reviewResultDialog.counts = data.counts || {"approved": 0, "rejected": 0, "all": 0}
        this.reviewResultDialog.visible = normalizedDialogList.length > 0;
        // this.startExpireNoticeTimer();
      } catch (err) {
        this.reviewResultDialog.list = [];
        this.reviewResultDialog.total = 0;
        this.reviewResultDialog.visible = false;
        this.reviewResultDialog.counts = {"approved": 0, "rejected": 0, "all": 0}
        this.reviewResultDialog.animating = false;
        // this.clearExpireNoticeTimer();
      }
    },
    async loadReviewResultDialogPage() {
      const requestId = ++this.reviewResultDialog.requestId;
      this.reviewResultDialog.loading = true;
      try {
        const res = await req.send(req.Apis.customer.aggregation.reviewResult, {
          page: this.reviewResultDialog.page,
          page_size: this.reviewResultDialog.page_size,
        });
        const data = res.data || {};
        if (requestId !== this.reviewResultDialog.requestId) return;
        const list = data.list || data.data || [];
        this.reviewResultDialog.list = (Array.isArray(list) ? list : [])
          .map(item => this.normalizeResultDialogRow(item))
          .filter(item => hasValue(item.budget_name));
        this.reviewResultDialog.total = Number(data.total != null ? data.total : this.reviewResultDialog.total);
        if (data.counts) this.reviewResultDialog.counts = data.counts;
      } catch (err) {
        if (requestId === this.reviewResultDialog.requestId) this.$message.error('获取审核结果失败');
      } finally {
        if (requestId === this.reviewResultDialog.requestId) this.reviewResultDialog.loading = false;
      }
    },
    handleReviewResultDialogSizeChange(size) {
      this.reviewResultDialog.page_size = size;
      this.reviewResultDialog.page = 1;
      this.loadReviewResultDialogPage();
    },
    handleReviewResultDialogPageChange(page) {
      if (page === this.reviewResultDialog.page) return;
      this.reviewResultDialog.page = page;
      this.loadReviewResultDialogPage();
    },
    createEmptyTransOwner() {
      return {
        owner: '',
        weight: '',
      };
    },
    cloneOwnerRows(rows = []) {
      const source = Array.isArray(rows) ? rows : [];
      if (!source.length) {
        return [this.createEmptyTransOwner()];
      }
      return source.map((item) => ({
        ...item,
      }));
    },
    createEmptyEditForm(type = 'Add') {
      return {
        id: '',
        budget_name: '',
        product_ids: [],
        identify_code: '',
        sale_type: '',
        owners: this.cloneOwnerRows(),
        agent_name: '',
        subject_type: type === 'Add' ? '2' : '',
        remark: '',
      };
    },
    createEmptyTransForm() {
      return {
        id: '',
        budget_name: '',
        identify_code: '',
        sale_type: '',
        agent_name: '',
        owners: this.cloneOwnerRows(),
        belong_name: '',
        customer_from: '',
      };
    },
    resetEditDialogState() {
      this.editForm.loading = false;
      this.editForm.type = 'Add';
      this.editForm.form = this.createEmptyEditForm('Add');
      this.ProductOptions = [];
      this.editProdSalorDlg.options = [];
      if (this.$refs.editForm) {
        this.$refs.editForm.resetFields();
        this.$refs.editForm.clearValidate();
      }
    },
    resetTransDialogState() {
      this.transForm.loading = false;
      this.transForm.type = 'Add';
      this.transForm.form = this.createEmptyTransForm();
      this.editProdSalorDlg.options = [];
      if (this.$refs.transForm) {
        this.$refs.transForm.resetFields();
        this.$refs.transForm.clearValidate();
      }
    },
    getFilledOwnerWeightRows(rows = []) {
      if(this.isChannelSale) {
        return rows
      }
      return (Array.isArray(rows) ? rows : []).filter(
        (item) => item && item.owner && this.sanitizeTransferWeight(item.weight) !== '',
      );
    },
    validateOwnerWeightRows(value, callback) {
      const rows = Array.isArray(value) ? value : [];


      if(!this.isChannelSale) {
        // const hasAnyValue = rows.some(
        //   (item) => item && (item.owner || this.sanitizeTransferWeight(item.weight)),
        // );
        // if (!rows.length || !hasAnyValue) {
        //   callback(new Error('请选择销售'));
        //   return;
        // }
        // const incompleteRow = rows.find(
        //   (item) => !item || !item.owner || this.sanitizeTransferWeight(item.weight) === '',
        // );
        // if (incompleteRow) {
        //   callback(new Error('请选择销售及权重'));
        //   return;
        // }

        const validRows = this.getFilledOwnerWeightRows(rows);
        // if (validRows.length === 0) {
        //   callback(new Error('请填写权重'));
        //   return;
        // }

        const invalidWeightMsg = validRows
          .map((item) => this.validateTransferWeight(item.weight))
          .find(Boolean);
        if (invalidWeightMsg) {
          callback(new Error(invalidWeightMsg));
          return;
        }
      }


      const duplicateOwner = rows.find(
        (item, index) => rows.findIndex(row => `${row.owner}` === `${item.owner}`) !== index,
      );
      if (duplicateOwner) {
        callback(new Error('存在相同名称的销售'));
        return;
      }
      // const totalWeight = rows.reduce(
      //   (sum, item) => sum + Number(this.normalizeTransferWeightValue(item.weight, '0')),
      //   0,
      // );
      // if (Math.abs(totalWeight - 100) > 0.0001) {
      //   callback(new Error('权重总和必须是100%'));
      //   return;
      // }
      callback();
    },
    appendTransOwner() {
      this.transForm.form.owners.push(this.createEmptyTransOwner());
      this.clearTransOwnerValidate();
    },
    removeTransOwner(index) {
      // if (index <= 0) return;
      this.transForm.form.owners.splice(index, 1);
      this.clearTransOwnerValidate();
    },
    clearTransOwnerValidate() {
      if (this.$refs.transForm) {
        this.$refs.transForm.clearValidate('owners');
      }
    },
    appendEditOwnerWeightRow() {
      this.editForm.form.owners.push(this.createEmptyTransOwner());
      this.clearEditOwnerWeightValidate();
    },
    removeEditOwnerWeightRow(index) {
      // if (index <= 0) return; // 允许删除第一个
      this.editForm.form.owners.splice(index, 1);
      this.clearEditOwnerWeightValidate();
    },
    clearEditOwnerWeightValidate() {
      if (this.$refs.editForm) {
        this.$refs.editForm.clearValidate('owners');
      }
    },
    sanitizeTransferWeight(value) {
      if (value === undefined || value === null) {
        return '';
      }
      return `${value}`.trim().replace(/%$/, '').trim();
    },
    normalizeTransferWeightInput(value) {
      const text = `${value || ''}`.replace(/[^\d.]/g, '');
      const parts = text.split('.');

      if (parts.length === 1) {
        return parts[0];
      }

      return `${parts[0]}`;
    },
    normalizeTransferWeightValue(value, defaultValue = '') {
      const text = this.sanitizeTransferWeight(value);

      if (!text) {
        return defaultValue;
      }

      const num = Number(text);
      if (Number.isNaN(num)) {
        return text;
      }

      return num.toFixed(0);
    },
    validateTransferWeight(value) {
      const text = this.sanitizeTransferWeight(value);
      if (!text) {
        return '请填写权重';
      }

      if (!/^(?:\d+\.?\d*|\.\d+)$/.test(text)) {
        return '请填写数字';
      }

      const num = Number(text);
      if (Number.isNaN(num)) {
        return '请填写数字';
      }

      if (num < 0) {
        return '权重不能小于0';
      }

      if (num > 100) {
        return '权重不能大于100';
      }

      // if (!/^(?:\d+(?:\.\d{1,2})?|\.\d{1,2})$/.test(text)) {
      //   return '权重最多两位小数';
      // }

      if(!/^-?(0|[1-9]\d*)$/.test(text)){
        return '权重必须是整数';
      }

      return '';
    },
    handleTransOwnerWeightInput(index, value) {
      const text = this.normalizeTransferWeightInput(value);
      if (text !== value) {
        this.transForm.form.owners[index].weight = text;
      }
      this.clearTransOwnerValidate();
    },
    handleTransOwnerWeightBlur(index) {
      const row = (this.transForm.form.owners || [])[index];
      if (!row) return;

      const error = this.validateTransferWeight(row.weight);
      if (!error) {
        row.weight = this.normalizeTransferWeightValue(row.weight);
      }
      this.clearTransOwnerValidate();
    },
    handleEditOwnerWeightInput(index, value) {
      const text = this.normalizeTransferWeightInput(value);
      if (text !== value) {
        this.editForm.form.owners[index].weight = text;
      }
      this.clearEditOwnerWeightValidate();
    },
    handleEditOwnerWeightBlur(index) {
      const row = (this.editForm.form.owners || [])[index];
      if (!row) return;

      const error = this.validateTransferWeight(row.weight);
      if (!error) {
        row.weight = this.normalizeTransferWeightValue(row.weight);
      }
      this.clearEditOwnerWeightValidate();
    },
    normalizeExpireDialogRow(row = {}) {
      return {
        ...row,
        budget_name: pickValue(row, ['budget_name']) || '--',
        sale_type_text:
          pickValue(row, ['sale_type_text']) ||
          this.getSaleTypeLabel(pickValue(row, ['sale_type'])),
        identify_code: pickValue(row, ['identify_code']) || '--',
        product_names: pickValue(row, ['product_names']) || '--',
        agent_name: pickValue(row, ['agent_name']) || '--',
        release_time: pickValue(row, ['release_time']) || '--',
        remaining_text:
          pickValue(row, ['remaining_text']) ||
          (hasValue(row.remaining_days) ? `剩余${row.remaining_days}天` : '--'),
      };
    },
    normalizeExpireNoticeRow(row = {}) {
      const budgetName = pickValue(row, ['budget_name']) || '--';
      const releaseTime = pickValue(row, ['release_time']) || '--';
      const remainingText =
        pickValue(row, ['remaining_text']) ||
        (hasValue(row.remaining_days) ? `剩余${row.remaining_days}天` : '');

      return {
        ...row,
        text: `【客保期提醒】聚合「${budgetName}」将于 ${releaseTime} 到期，${remainingText}，请及时跟进，到期后该聚合将进入公海客户池。`,
      };
    },
    startExpireNoticeTimer() {
      this.clearExpireNoticeTimer();

      if (!this.hasMultipleExpireNotice) {
        return;
      }

      this.expireNotice.timer = setInterval(() => {
        if (this.expireNotice.animating) return;
        this.expireNotice.animating = true;
      }, 3000);
    },
    clearExpireNoticeTimer() {
      if (this.expireNotice.timer) {
        clearInterval(this.expireNotice.timer);
        this.expireNotice.timer = null;
      }
    },
    handleExpireNoticeTransitionEnd() {
      if (!this.expireNotice.animating || !this.hasMultipleExpireNotice) {
        return;
      }

      this.expireNotice.currentIndex =
        (this.expireNotice.currentIndex + 1) % this.expireNotice.list.length;
      this.expireNotice.animating = false;
    },
    async getBudgetExpireNotice() {
      try {
        this.expireDialog.page = 1;
        const res = await req.send(req.Apis.customer.aggregation.budgetExpire, {
          type: 2,
          page: this.expireDialog.page,
          page_size: this.expireDialog.page_size,
        });

        const data = res.data || {};
        const list = data.list || data.data || [];
        const sourceList = Array.isArray(list) ? list : [];
        const normalizedDialogList = sourceList
          .map(item => this.normalizeExpireDialogRow(item))
          .filter(item => hasValue(item.budget_name));
        const normalizedNoticeList = sourceList
          .map(item => this.normalizeExpireNoticeRow(item))
          .filter(item => hasValue(item.text));

        this.expireDialog.list = normalizedDialogList.slice(0, this.expireDialog.page_size);
        this.expireDialog.total = Number(data.total || normalizedDialogList.length);
        this.expireDialog.visible = normalizedDialogList.length > 0;
        this.expireNotice.list = normalizedNoticeList;
        this.expireNotice.currentIndex = 0;
        this.expireNotice.animating = false;
        this.startExpireNoticeTimer();
      } catch (err) {
        this.expireDialog.list = [];
        this.expireDialog.total = 0;
        this.expireDialog.visible = false;
        this.expireNotice.list = [];
        this.expireNotice.currentIndex = 0;
        this.expireNotice.animating = false;
        this.clearExpireNoticeTimer();
      }
    },
    async loadExpireDialogPage() {
      const requestId = ++this.expireDialog.requestId;
      this.expireDialog.loading = true;
      try {
        const res = await req.send(req.Apis.customer.aggregation.budgetExpire, {
          type: 2,
          page: this.expireDialog.page,
          page_size: this.expireDialog.page_size,
        });
        const data = res.data || {};
        if (requestId !== this.expireDialog.requestId) return;
        const list = data.list || data.data || [];
        this.expireDialog.list = (Array.isArray(list) ? list : [])
          .map(item => this.normalizeExpireDialogRow(item))
          .filter(item => hasValue(item.budget_name));
        this.expireDialog.total = Number(data.total != null ? data.total : this.expireDialog.total);
      } catch (err) {
        if (requestId === this.expireDialog.requestId) this.$message.error('获取客保到期提醒失败');
      } finally {
        if (requestId === this.expireDialog.requestId) this.expireDialog.loading = false;
      }
    },
    handleExpireDialogSizeChange(size) {
      this.expireDialog.page_size = size;
      this.expireDialog.page = 1;
      this.loadExpireDialogPage();
    },
    handleExpireDialogPageChange(page) {
      if (page === this.expireDialog.page) return;
      this.expireDialog.page = page;
      this.loadExpireDialogPage();
    },
    toggleQueryExpand() {
      this.queryExpanded = !this.queryExpanded;
    },
    clearAggregationSelection() {
      this.selectedAggregationRows = [];
      if (this.$refs.aggregationTable) {
        this.$refs.aggregationTable.clearSelection();
      }
    },
    handleAggregationSelectionChange(rows = []) {
      this.selectedAggregationRows = rows;
    },
    handleBatchUnbindOpen() {
      if (!this.hasAggregationSelection) return;
      this.batchUnbindDialog.display = true;
    },
    handleBatchUnbindClose() {
      this.batchUnbindDialog.display = false;
    },
    handleBatchUnbindResultClose() {
      this.batchUnbindResultDialog.display = false;
      this.batchUnbindResultDialog.success_count = 0;
      this.batchUnbindResultDialog.failed_count = 0;
      this.batchUnbindResultDialog.failed_items = [];
    },
    showBatchUnbindResult(data = {}) {
      this.batchUnbindResultDialog.success_count = Number(
        data.success_count || 0,
      );
      this.batchUnbindResultDialog.failed_count = Number(data.failed_count || 0);
      this.batchUnbindResultDialog.failed_items = Array.isArray(data.failed_items)
        ? data.failed_items
        : [];
      this.batchUnbindResultDialog.display = true;
    },
    async handleBatchUnbindConfirm() {
      try {
        let ids = (this.selectedAggregationRows || []).map(item => item.id);
        const params = {
          ids: ids.join(',')
        };

        this.batchUnbindDialog.loading = true;
        const res = await req
          .send(req.Apis.customer.aggregation.batchUnbind, params)
          .fin(() => {
            this._getList();
            this.batchUnbindDialog.loading = false;
          });
        this.batchUnbindDialog.display = false;
        this.showBatchUnbindResult((res || {}).data || {});
      } catch (err) {
        // this.$message.error(`解绑失败：${err.message || '未知错误'}`);
      }

      // this.$message.warning('当前仅增加页面显示，批量解绑逻辑暂未接入');
    },
    handleBatchTransOpen() {
      if (!this.hasAggregationSelection) return;
      this.batchTransDialog.display = true;
      this.$nextTick(() => {
        if (this.$refs.batchTransDialog) {
          this.$refs.batchTransDialog.clearValidate();
        }
      });
    },
    handleBatchTransResultClose() {
      this.batchTransResultDialog.display = false;
      this.batchTransResultDialog.success_count = 0;
      this.batchTransResultDialog.failed_count = 0;
      this.batchTransResultDialog.failed_items = [];
    },
    showBatchTransResult(data = {}) {
      this.batchTransResultDialog.success_count = Number(
        data.success_count || 0,
      );
      this.batchTransResultDialog.failed_count = Number(data.failed_count || 0);
      this.batchTransResultDialog.failed_items = Array.isArray(data.failed_items)
        ? data.failed_items
        : [];
      this.batchTransResultDialog.display = true;
    },
    handleBatchTransClose() {
      this.batchTransDialog.display = false;
      this.batchTransDialog.form.owner = '';
      if (this.$refs.batchTransDialog) {
        this.$refs.batchTransDialog.resetFields();
      }
    },
    async handleBatchTransConfirm() {
      this.$refs.batchTransDialog.validate(async (valid) => {
        if (!valid) {
          return false;
        }

        try {
          this.batchTransDialog.loading = true;
          let ids = (this.selectedAggregationRows || []).map(item => item.id);
          const params = {
            ids: ids.join(','),
            owner: this.batchTransDialog.form.owner
          };
          const api = req.Apis.customer.aggregation.batchTransfer;
          const res = await req.send(api, params).fin(() => {
            this.batchTransDialog.loading = false;
          });

          this._getList(); // 刷新列表
          this.batchTransDialog.display = false;
          this.batchTransDialog.form.owner = '';
          this.showBatchTransResult((res || {}).data || {});
        } catch (err) {
          this.batchTransDialog.loading = false;
          // this.$message.error(`编辑失败：${err.message || '未知错误'}`);
        }

        return true;
      });
    },
    getCustomerFrom(source) {
      return this.CustomerSourcesMap[source] || '--'
    },
    async handleDownload() {
      let _query = this.query.form;
      const params = {
        ..._query,
      };

      if (params.agent_name.trim() === '') {
        delete params.agent_name
      }
      if(this.showAssign) {
        params.agent_name = '';
      }

      try {
        const res = await req.send(req.Apis.customer.budgetBind.download, params);
        if (res.code === 200) {
          const url = res.data.url;
          if(url) {
            const a = document.createElement('a')
            a.href = url
            a.download = '聚合预算列表.csv'
            a.click()
          }
        }
      } catch (err) {
        // this.$message.error(`${err.message || '未知错误'}`);
      }
    },
    handleCompanyName() {
      const compantName = (this.editForm.form.identify_code || '').replace(/[，,]/g, ',').split(',')[0] || '';
      const budgetName = this.editForm.form.budget_name || '';
      if (compantName && budgetName.trim() === '') {
        const suffixPattern = /(?:有限责任公司|有限公司|股份有限公司|股份公司|（普通合伙）|（特殊普通合伙）|（有限合伙）|（个人独资）|专业合作社|分公司)$/;
        this.editForm.form.budget_name = compantName.replace(suffixPattern, '');
      }
    },
    async getLogList() {
      try {
        const { data } = await req.send(req.Apis.customer.budgetBind.log, {
          config_id: this.logId,
          page: this.logPage,
          page_size: this.logPageSize,
          type: 2,
        });
        this.logList = data.list;
        this.logTotal = Number(data.total);
      } catch (err) {}
    },
    handleChangeLogPage(n) {
      this.logPage = n;
      this.getLogList();
    },
    // 操作按钮: 日志
    handleCtrlLogOpen(row) {
      this.logVisible = true;
      this.logId = row.id;
      this.getLogList();
    },
    // 操作按钮: 分配
    async handleAssignConfirm(row) {
      const params = { id: this.assignForm.form.id };
      await req.send(req.Apis.customer.budgetBind.assign, params);
      this.$message.success('操作成功');
      this.assignForm.form = {};
      this.assignForm.display = false;
      this._getList();
    },
    // 操作按钮: 失效&有效
    handleCtrlCancel(row) {
      this.$confirm('确定操作吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        try {
          await req.send(req.Apis.customer.budgetBind.review, { id: row.id });
          this.$message.success('操作成功');
          this._getList();
        } catch (err) {}
      });
    },
    // 输入并选择销售名称下拉框
    async _searchSalors(key) {
      if (!key) return [];
      try {
        this.editProdSalorDlg.searchLoading = true;
        const res = await req
          .send(req.Apis.customer.common.sales, {
            is_budget: 1,
            names: key,
          })
          .fin(() => {
            this.editProdSalorDlg.searchLoading = false;
          });
        this.editProdSalorDlg.options = (res.data.data || []).map(item => {
          return {
            ...item,
            id: Number(item.id)
          }
        });
      } catch (err) {
        // this.$message.error(`获取销售失败：${err.message || '未知错误'}`);
      }
    },

    // 输入并选择销售名称下拉框
    async _searchSalors2(key) {
      if (!key) return [];
      try {
        this.editProdSalorDlg.searchLoading = true;
        const res = await req
          .send(req.Apis.customer.common.sales, {
            is_budget: 5,
            names: key,
          })
          .fin(() => {
            this.editProdSalorDlg.searchLoading = false;
          });
        this.editProdSalorDlg.options = (res.data.data || []).map(item => {
          return {
            ...item,
            id: Number(item.id)
          }
        });
      } catch (err) {
        this.$message.error(`获取销售失败：${err.message || '未知错误'}`);
      }
    },
    async getUserInfo() {
      const res = await req.send(req.Apis.sales.user.userInfo);
      if (res.code === 200) {
        this.userInfo = res.data;
      }
    },
    async handleSearchProducts(val){
      this.productsLoading = true;
      const res = await req.send(req.Apis.customer.productSeries.products, {
        names: val,
        page: 1,
        page_size: 100,
      });
      if(res.code === 200) {
        const {data} = res;
        this.ProductOptions = (data.data || []).map(item => {
          return {label: item.name, value: item.id}
        })
      }
      this.productsLoading = false;
    },

    async handleSearchProducts2(val){
      this.productsLoading = true;
      const res = await req.send(req.Apis.customer.productSeries.products2, {
        names: val,
        page: 1,
        page_size: 9999,
      });
      if(res.code === 200) {
        const {data} = res;
        this.ProductOptions = (data.data || []).map(item => {
          return {label: item.name, value: item.id}
        })
      }
      this.productsLoading = false;
    },

    // 获取用户列表数据
    async _getList(option = {}) {
      try {
        let _query = this.query.form;
        const params = {
          // page: _query.page,
          // page_size: _query.page_size,
          ..._query,
          ...option,
          is_across: _query.is_across === '' ? -1 : _query.is_across
        };

        if (this.$route.query.id) {
          params.id = Number(this.$route.query.id || '');
        }
        if (params.agent_name.trim() === '') {
          delete params.agent_name
        }
        if(this.showAssign) {
          params.agent_name = '';
        }

        this.table.loading = true;
        // req
        const res = await req
          .send(req.Apis.customer.aggregation.list, params)
          .fin(() => {
            this.table.loading = false;
          });
        const dv = res.data || {};
        this.table.list = [...(dv.list || [])].map(item => {
          if(this.isChannelSale) {
            // let _owner_name = '-';
            // let _owner_weight = '-';

            // if(item.owners && Array.isArray(item.owners) && item.owners.length > 0) {
            //   let owner = item.owners.find(_item => _item.is_main === 1) || item.owners[0];
            //   _owner_name = owner.owner_name;
            //   _owner_weight = `${owner.weight}%`
            // }

            // return {
            //   ...item,
            //   _owner_name: _owner_name,
            //   _owner_weight: _owner_weight,
            //   owners_name: (item.owners || []).map(_owner => _owner.owner_name).join(',')
            // }
            return {
              ...item,
              _owner_name: (item.owners || []).map(_owner => _owner.owner_name).join(',') || '-'
            }
          } else {
            let _owner_name = '-';
            let _owner_weight = '-';

            if(item.owners && Array.isArray(item.owners) && item.owners.length > 0) {
              let owner = item.owners.find(_item => _item.is_main === 1) || item.owners[0];
              _owner_name = owner.owner_name;
              if(!['代理', '趣头条'].includes(owner.owner_name)) {
                _owner_weight = `${owner.weight}%`
              }
            }

            return {
              ...item,
              _owner_name: _owner_name,
              _owner_weight: _owner_weight,
              owners_name: (item.owners || []).map(_owner => {
                if(['代理', '趣头条'].includes(_owner.owner_name)){
                  return `${_owner.owner_name}`
                }
                return `${_owner.owner_name} ${_owner.weight}%`
              }).join(',')
            }
          }
        });

        this.table.total = Number(dv.total || 0);
      } catch (err) {
        this.$message.error(`获取用户列表失败：${err.message || '未知错误'}`);
      }
    },

    // async 添加/编辑
    async processEdit() {
      try {
        this.editForm.loading = true;
        const ownerRows = this.getFilledOwnerWeightRows(this.editForm.form.owners);

        const params = {
          ...this.editForm.form,
          product_ids: this.editForm.form.product_ids ? this.editForm.form.product_ids.join(',') : [],
          is_owner: 1,
          owners: ownerRows
        };

        if (!this.isAdminOrChannelSale) {
          delete params.owner;
          delete params.agent_name;
        }

        const api =
          req.Apis.customer.aggregation[
            this.editForm.type === 'Add' ? 'add' : 'update'
          ];
        await req.send(api, params).fin(() => {
          this.editForm.loading = false;
        });

        this._getList(); // 刷新列表
        this.editForm.display = false;
        this.resetEditDialogState();
      } catch (err) {
        this.editForm.loading = false;
        // this.$message.error(`编辑失败：${err.message || '未知错误'}`);
      }
    },

    // async 添加/编辑
    async processTrans() {
      try {
        this.transForm.loading = true;
        const ownerRows = this.getFilledOwnerWeightRows(this.transForm.form.owners);

        const params = {
          id: this.transForm.form.id,
          owners: ownerRows
        };
        const api = req.Apis.customer.aggregation.transfer;
        await req.send(api, params).fin(() => {
          this.transForm.loading = false;
        });

        this._getList(); // 刷新列表
        this.transForm.display = false;
        this.resetTransDialogState();
      } catch (err) {
        this.transForm.loading = false;
        // this.$message.error(`编辑失败：${err.message || '未知错误'}`);
      }
    },

    handleFormClose() {
      if (this.editForm.display) {
        this.editForm.display = false;
        this.resetEditDialogState();
      }
      if (this.transForm.display) {
        this.transForm.display = false;
        this.resetTransDialogState();
      }
    },

    // 筛选
    handleFilter() {
      this.query.form.page = 1;
      this.clearAggregationSelection();
      this._getList();
    },

    handleReset() {
      this.query.form.budget_name = '';
      this.query.form.identify_code = '';
      this.query.form.owner_name = '';
      this.query.form.weight_order = '';
      this.query.form.subject_type = '';
      this.query.form.sale_type = '';
      this.query.form.product_ids = [];
      this.query.form.agent_name = '';
      this.query.form.status = '';
      this.query.form.customer_from = '';
      this.query.form.is_weight = '';
      this.query.form.is_across = undefined;
      this.query.form.page = 1;
      this.query.form.product_name = '';
      this.clearAggregationSelection();
    },
    // 页量改变
    handlePageSizeChange(pageSize) {
      this.query.form.page_size = Number(pageSize);
      this._getList();
    },

    // 页码改变
    handleQueryPage(page) {
      this.query.form.page = Number(page);
      this._getList();
    },
    handleTableSortChange({ prop, order } = {}) {
      if (prop !== 'owners_name') {
        return;
      }

      this.query.form.page = 1;
      this.query.form.weight_order = order === 'ascending'
        ? 'asc'
        : order === 'descending'
          ? 'desc'
          : '';
      this.clearAggregationSelection();
      this._getList();
    },

    // 编辑弹窗
    // eslint-disable-next-line camelcase
    async handleEdit(
      type = 'Add',
      { id, budget_name, product_ids, identify_code, product_names, sale_type,
        owners, subject_type, remark, agent_name
      } = {},
    ) {
      this.resetEditDialogState();
      this.editForm.type = type || 'Add';
      this.editForm.form = {
        id,
        budget_name,
        product_ids: product_ids && typeof product_ids === 'string' ? product_ids.split(',') : [],
        identify_code,
        sale_type: (parseInt(sale_type) || '') + '',
        // owner: [],
        owners: type === 'Add'
          ? this.cloneOwnerRows()
          : this.cloneOwnerRows(owners),
        agent_name: agent_name,
        subject_type: type === 'Add' ? '2' : subject_type,
        remark
      };

      this.editForm.display = true;
      try {
        if (product_names) {
          await this.handleSearchProducts2(product_names);
        }
        if (owners) {
          const name = owners.map(item => item.owner_name).join(',')
          await this._searchSalors2(name);
        }
      } finally {}
    },

    async handleTrans(
      { id, budget_name, identify_code, sale_type, belong_name, customer_from, owners
      } = {},
    ) {
      this.resetTransDialogState();
      this.transForm.form = {
        id,
        budget_name,
        identify_code,
        sale_type: (parseInt(sale_type) || '') + '',
        agent_name: '',
        owners: this.cloneOwnerRows(owners),
        belong_name,
        customer_from: this.CustomerSourcesMap[customer_from]
      };

      try {
        if (owners) {
          const name = owners.map(item => item.owner_name).join(',')
          await this._searchSalors2(name);
        }
      } finally {}

      this.transForm.display = true;
    },

    // 解绑弹窗
    handleUnbind(item = {}) {
      this.unbindForm.form = {
        ...item
      };
      this.unbindForm.display = true;
    },

    // 分配弹窗
    handleAssign(item = {}) {
      this.assignForm.form = {
        ...item
      };
      this.assignForm.display = true;
    },

    // 确认解绑
    async handleUnbindConfirm() {
      try {
        const params = {
          id: this.unbindForm.form.id
        };

        this.table.loading = true;
        // req
        const res = await req
          .send(req.Apis.customer.aggregation.unbind, params)
          .fin(() => {
            this._getList();
            this.table.loading = false;
          });
        if (res.code === 200) {
          this.$message.success('解绑成功！')
        }
        this.unbindForm.form = {};
        this.unbindForm.display = false;
      } catch (err) {
        // this.$message.error(`解绑失败：${err.message || '未知错误'}`);
      }
    },
    // 提交编辑
    submitEditFormAction() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          this.processEdit();
        } else {
          return false;
        }
      });
    },

    // 提交编辑
    submitTransFormAction() {
      this.$refs['transForm'].validate((valid) => {
        if (valid) {
          this.processTrans();
        } else {
          return false;
        }
      });
    },
  },
};

</script>

<style lang="less" scoped>

.expire-notice {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 0 16px;
  height: 44px;
  border-radius: 8px;
  background: linear-gradient(90deg, #fff4e8 0%, #fffaf5 100%);
  border: 1px solid #ffd3a8;
  box-shadow: 0 4px 12px rgba(230, 106, 0, 0.08);
}

.expire-notice__icon {
  flex: 0 0 auto;
  margin-right: 12px;
  color: #e67a00;
  font-size: 18px;
}

.expire-notice__viewport {
  flex: 1;
  height: 44px;
  overflow: hidden;
}

.expire-notice__track {
  will-change: transform;
}

.expire-notice__track.is-animating {
  transition: transform 0.45s ease;
}

.expire-notice__item {
  display: flex;
  align-items: center;
  height: 44px;
  color: #d14b00;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}

/deep/ .expire-dialog .el-dialog__body {
  padding-top: 12px;
}

/deep/ .expire-dialog .el-dialog__header {
  border-bottom: 1px solid #f0f2f5;
}

.query-conditions {
  margin-bottom: 24px;
}

.query-form {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 0;
}

.query-row {
  flex: 1 1 720px;
}

.query-item {
  margin-bottom: 12px;
}

.query-item--actions {
  display: flex;
  align-items: flex-start;
}

.query-buttons {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}

.query-toggle {
  padding: 0;
}

.query-extra-actions {
  flex: 1 1 300px;
  min-width: 300px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: flex-start;
}

.query-extra-buttons {
  margin-left: 12px;
}

/deep/ .my_el_form_item .el-form-item__content{
  line-height: 39px;
  max-height: 400px;
  overflow: auto;
}

/deep/ .query-conditions .el-form-item {
  display: block;
  margin-right: 0;
  margin-bottom: 0;
}

/deep/ .query-conditions .el-form-item__content {
  display: block;
}

/deep/ .query-buttons .el-button + .el-button {
  margin-left: 0;
}

.query-data {
  // table
  .query-table {
    position: relative;
    overflow: hidden;
  }
}

.transfer-owner-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.transfer-owner-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.transfer-owner-select {
  flex: 1;
}

.transfer-owner-weight {
  width: 180px;
  flex: 0 0 180px;
}

.batch-unbind-result__summary {
  display: flex;
  margin-bottom: 20px;
}

.batch-unbind-result__card {
  flex: 1;
  padding: 16px 20px;
  border-radius: 8px;
}

.batch-unbind-result__card + .batch-unbind-result__card {
  margin-left: 16px;
}

.batch-unbind-result__card--success {
  background: #f0f9eb;
}

.batch-unbind-result__card--failed {
  background: #fef0f0;
}

.batch-unbind-result__label {
  margin-bottom: 8px;
  color: #606266;
  font-size: 14px;
}

.batch-unbind-result__value {
  color: #303133;
  font-size: 28px;
  font-weight: 600;
  line-height: 1;
}

.batch-unbind-result__details-title {
  margin-bottom: 12px;
  color: #303133;
  font-size: 14px;
  font-weight: 600;
}

.batch-unbind-result__empty {
  padding: 24px 0;
  color: #909399;
  text-align: center;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.no-wrap-tag {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

@media screen and (max-width: 767px) {
  .query-extra-actions {
    min-width: 100%;
    justify-content: flex-start;
  }

  .query-extra-buttons {
    margin-top: 12px;
    margin-left: 0;
  }
}
</style>
